import { render, staticRenderFns } from "./StockPackagingBreakdownCell.vue?vue&type=template&id=ab601138&scoped=true"
import script from "./StockPackagingBreakdownCell.vue?vue&type=script&lang=js"
export * from "./StockPackagingBreakdownCell.vue?vue&type=script&lang=js"
import style0 from "./StockPackagingBreakdownCell.vue?vue&type=style&index=0&id=ab601138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab601138",
  null
  
)

export default component.exports